import React, { ReactElement, ReactNode } from "react";
import { useStyles } from "./FormLayout.styles";

interface MainLayoutProps {
	children: ReactNode;
}

const FormLayout = ({ children }: MainLayoutProps): ReactElement => {
	const styles = useStyles();

	return <div className={styles.formContainer}>{children}</div>;
};
export default FormLayout;
